module.exports = __webpack_public_path__ + "media/images/profile/phone-circle-5bfb5b8783489c5aa92250ebb0f3f3e8.svg";